// extracted by mini-css-extract-plugin
export default {"melodyVideo":"FI-z","isFullWidth":"GI-z","landingPageVideo":"HI-z","play":"II-z","iframeVideo":"JI-z","playHidden":"KI-z","fullwidth":"LI-z"};